import { helpers } from './helpers';
import { modals } from './modals';
import { silenSoundShowcase } from './silen-sound-showcase';
import { dpjFaq } from './dpj-faq';
import { icons } from './icons';

export const companyServices = {
    init: () => {
        console.debug("companyServices.js: init");
        if ($("#inredningshjalpen-wrapper").length) {
            console.debug("companyServices.js: inredningshjalpen-wrapper found. TODO: this should be checked before we load the modu");
            return;
        }
        companyServices.scrollToContact();
        const forms = document.querySelectorAll("#company-services-wrapper .contact__form, .project-sales-wrapper .contact__form, .project-sales-wrapper div .contact__form")
        forms.forEach(form => {
            form.addEventListener("submit", (ev) => {
                ev.preventDefault();
                companyServices.subscribeToKlaviyoList();
                // Set location in form when submitting
                // race timeout to avoid locking up the UI for too long
                Promise.race([
                    helpers.getLocationData(),
                    helpers.timeoutPromise(1500)
                ]).then((data) => {
                    const locationString = `${data.city} (${data.region}), ${data.country}`;
                    companyServices.setLocation(form, locationString, data.provider)
                    companyServices.postForm(ev.target)
                    companyServices.clearForm(ev.target)
                }).catch((err) => {
                    // if no provider is set, it means the timeout was reached
                    if (err.provider === undefined) {
                        console.log(err)
                        companyServices.setLocation(form, err, -1)

                    } else {
                        console.log(err)
                        companyServices.setLocation(form, err.error, err.provider)
                    }
                    companyServices.postForm(ev.target)
                    companyServices.clearForm(ev.target)
                })
            })
        });

        // Activate arrows for slider
        if ($('.slider-section-wrapper').length) {
            $(document).on("click", ".slider-section-wrapper .traverse-arrow", helpers.traverseSliderImages);
            helpers.traverseSliderImagesInitScroll();
        }

        // Insert contact form into specific class, used to get around limitations of prestashop
        companyServices.insertContactFormFromFaq();
        companyServices.insertCompanyPagesCarouselNew();

        if ($('.product-features-alt__col-video-wrap').length) {
            silenSoundShowcase.init();
        }

        if (helpers.isSmallDevice()) {
            $(".block_video_player_about").html('<iframe style="width:100%;height:300px;" src="https://www.youtube.com/embed/KxtYBhWss0Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>');
        } else {
            $(".block_video_player_about").html('<iframe style="width:100%;height:700px;" src="https://www.youtube.com/embed/KxtYBhWss0Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>');
        }

        companyServices.initCombinationComparisonTable();
    },
    subscribeToKlaviyoList: () => {
        var email = $(".contact__form #email").val();
        if (typeof email == "undefined") {
            email = $(".contact__form [name='email']").val();
        }
        if (email) {
            var url = `${prestashop.urls.base_url}misc/klaviyo-lead-add-profile-to-list.php?email=${email}&pathname=${window.location.pathname}`;
            $.ajax({
                type: "POST",
                url: url,
                dataType: "json"
            });
        }
    },
    displayOkMsg: (lang) => {
        lang = lang.toUpperCase();

        try {
            let ModalText_thanks = "<h2>Thank you for reaching out!</h2>";
            switch (lang) {
                case "SV":
                case "SE":
                    ModalText_thanks = `
                    <h2>Tack för ditt meddelande!</h2>
                    <div>Vi kontaktar dig så snart som möjligt.<br> Har du några frågor? Mejla, chatta eller ring oss för snabb hjälp.</div>
                    <div class="company-services-modal-flex">
                        <div>
                            <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                            <div><a href="mailto:info@dpj.se">info@dpj.se</a></div>
                        </div>
                        <div>
                            <div><div class="dpj-icon dpj-icon-headphones-flat" data-icon="headphones-flat"></div></div>
                            <div><a href="tel:+4684445424">+46 (0)8-444 54 24</a></div>
                        </div>
                        <div>
                            <div><div class="dpj-icon dpj-icon-house" data-icon="house"></div></div>
                            <div><a href="https://www.dpj.se/content/73-butik">Till Butiken</a></div>
                        </div>
                    </div>`;
                    break;
                case "DK":
                case "DA":
                    ModalText_thanks = `
                    <h2>Tak for din besked!</h2>
                    <div>Vi kontakter dig hurtigst muligt.<br>Har du nogen spørgsmål? Send en E-mail, chat eller ring til os for hurtig hjælp.</div>
                    <div class="company-services-modal-flex">
                        <div>
                            <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                            <div><a href="mailto:info-dk@dpj-workspace.com">info-dk@dpj-workspace.com</a></div>
                        </div>
                        <!--<div>
                            <div><div class="dpj-icon dpj-icon-headphones-flat" data-icon="headphones-flat"></div></div>
                            <div><a href="tel:+4580705706">+45 (0)80 70 57 06</a></div>
                        </div>-->
                    </div>`;
                    break;
                case "FI":
                    ModalText_thanks = `
                    <h2>Kiitos viestistäsi!</h2>
                    <div>Otamme sinuun yhteyttä mahdollisimman pian.<br> Onko sinulla kysymyksiä? Lähetä ne meille sähköpostilla, chatissa tai soita meille saadaksesi nopeaa apua.</div>
                    <div class="company-services-modal-flex">
                        <div>
                            <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                            <div><a href="mailto:info-fi@dpj-workspace.com">info-fi@dpj-workspace.com</a></div>
                        </div>
                        <div>
                            <div><div class="dpj-icon dpj-icon-headphones-flat" data-icon="headphones-flat"></div></div>
                            <div><a href="tel:+358800413816">+358 (0)800-413 816</a></div>
                        </div>
                    </div>`;
                    break;
                case "FR":
                    ModalText_thanks = `                   
                    <h2>Merci pour votre message !</h2>
                    <div>Nous vous répondons au plus vite.<br> Vous avez des questions ? Envoyez-nous un email ou posez votre question en direct sur le chat pour obtenir une réponse rapide.</div>
                    <div class="company-services-modal-flex">
                        <div>
                            <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                            <div><a href="mailto:info-fr@dpj-workspace.com">info-fr@dpj-workspace.com</a></div>
                        </div>
                    </div>`;
                    break;
                case "DE":
                    ModalText_thanks = `                    
                    <h2>Vielen Dank für Ihre Nachricht!</h2>
                    <div>Wir werden Sie so bald wie möglich kontaktieren.<br> Haben Sie noch Fragen? Kontaktieren Sie uns per E-Mail, Chat oder telefonisch für eine schnelle Antwort.</div>
                    <div class="company-services-modal-flex">
                        <div>
                            <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                            <div><a href="mailto:info-de@dpj-workspace.com">info-de@dpj-workspace.com</a></div>
                        </div>
                        <div>
                            <div><div class="dpj-icon dpj-icon-headphones-flat" data-icon="headphones-flat"></div></div>
                            <div><a href="tel:+498001815970">+49 (0)800-18 15 970</a></div>
                        </div>
                    </div>`;
                    break;
                case "AT":
                    ModalText_thanks = `
                    <h2>Vielen Dank für Ihre Nachricht!</h2>
                    <div>Wir werden Sie so bald wie möglich kontaktieren.<br> Haben Sie noch Fragen? Kontaktieren Sie uns per E-Mail, Chat oder telefonisch für eine schnelle Antwort.</div>
                    <div class="company-services-modal-flex">
                        <div>
                            <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                            <div><a href="mailto:info-at@dpj-workspace.com">info-at@dpj-workspace.com</a></div>
                        </div>
                        <div>
                            <div><div class="dpj-icon dpj-icon-headphones-flat" data-icon="headphones-flat"></div></div>
                            <div><a href="tel:+498001815970">+49 (0)800-18 15 970</a></div>
                        </div>
                    </div>`;
                    break;
                case "NL":
                    ModalText_thanks = `
                    <h2>Bedankt voor uw bericht!</h2>
                    <div>We nemen zo snel mogelijk contact met je op.<br> Heb je vragen? Mail of chat met ons voor snelle hulp.</div>
                    <div class="company-services-modal-flex">
                        <div>
                            <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                            <div><a href="mailto:info-nl@dpj-workspace.com">info-nl@dpj-workspace.com</a></div>
                        </div>
                    </div>`;
                    break;
            }

            modals.ol.html(`
                <div class="modal-box" id="company-services-modal">
                <div class="close-modal">
                <img src="${prestashop.urls.img_url}icons/cross.svg" alt="close">
                </div>
                ${ModalText_thanks}
                </div>
                `);

            $("#company-services-modal").show();
            modals.togglePageOverlay();
            icons.init();
        } catch (error) {
            console.log(error)
        }
    },
    displayFailMsg: (lang, msg) => {
        try {
            lang = lang.toUpperCase();
        } catch (error) {
            lang = "EN";
        }
        // fallback text
        let ModalText = `<h2>Oh no, something went wrong!</h2><p>${msg}</p>`;

        switch (lang) {
            case "SV":
            case "SE":
                ModalText = `
                <h2>Något gick fel!</h2>
                <div>Kontakta oss via e-post, chatt eller ring oss för snabb hjälp.</div>
                <div class="company-services-modal-flex">
                    <div>
                        <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                        <div><a href="mailto:info@dpj.se">info@dpj.se</a></div>
                    </div>
                    <div>
                        <div><div class="dpj-icon dpj-icon-headphones-flat" data-icon="headphones-flat"></div></div>
                        <div><a href="tel:+4684445424">+46 (0)8-444 54 24</a></div>
                    </div>
                    <div>
                        <div><div class="dpj-icon dpj-icon-house" data-icon="house"></div></div>
                        <div><a href="https://www.dpj.se/content/73-butik">Till Butiken</a></div>
                    </div>
                </div>
                <p>${msg}</p>`;
                break;

            case "DK":
            case "DA":
                ModalText = `
                <h2>Noget gik galt!</h2>
                <div>Kontakt os via e-mail eller chat for hurtig hjælp.</div>
                <div class="company-services-modal-flex">
                    <div>
                        <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                        <div><a href="mailto:info-dk@dpj-workspace.com">info-dk@dpj-workspace.com</a></div>
                    </div>
                </div>
                <p>${msg}</p>`;
                break;

            case "FI":
                ModalText = `
                <h2>Jokin meni pieleen!</h2>
                <div>Ota meihin yhteyttä sähköpostitse, chatissa tai soita meille saadaksesi nopeaa apua.</div>
                <div class="company-services-modal-flex">
                    <div>
                        <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                        <div><a href="mailto:info-fi@dpj-workspace.com">info-fi@dpj-workspace.com</a></div>
                    </div>
                    <div>
                        <div><div class="dpj-icon dpj-icon-headphones-flat" data-icon="headphones-flat"></div></div>
                        <div><a href="tel:+358800413816">+358 (0)800-413 816</a></div>
                    </div>
                </div>
                <p>${msg}</p>`;
                break;

            case "FR":
                ModalText = `
                <h2>Oups, quelque chose s'est mal passé !</h2>
                <div>Contactez-nous par e-mail ou chat pour une aide rapide.</div>
                <div class="company-services-modal-flex">
                    <div>
                        <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                        <div><a href="mailto:info-fr@dpj-workspace.com">info-fr@dpj-workspace.com</a></div>
                    </div>
                </div>
                <p>${msg}</p>`;
                break;

            case "DE":
                ModalText = `
                <h2>Etwas ist schiefgelaufen!</h2>
                <div>Kontaktieren Sie uns per E-Mail, Chat oder rufen Sie uns an für schnelle Hilfe.</div>
                <div class="company-services-modal-flex">
                    <div>
                        <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                        <div><a href="mailto:info-de@dpj-workspace.com">info-de@dpj-workspace.com</a></div>
                    </div>
                    <div>
                        <div><div class="dpj-icon dpj-icon-headphones-flat" data-icon="headphones-flat"></div></div>
                        <div><a href="tel:+498001815970">+49 (0)800-18 15 970</a></div>
                    </div>
                </div>
                <p>${msg}</p>`;
                break;

            case "AT":
                ModalText = `
                <h2>Etwas ist schiefgelaufen!</h2>
                <div>Kontaktieren Sie uns per E-Mail, Chat oder rufen Sie uns an für schnelle Hilfe.</div>
                <div class="company-services-modal-flex">
                    <div>
                        <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                        <div><a href="mailto:info-at@dpj-workspace.com">info-at@dpj-workspace.com</a></div>
                    </div>
                    <div>
                        <div><div class="dpj-icon dpj-icon-headphones-flat" data-icon="headphones-flat"></div></div>
                        <div><a href="tel:+498001815970">+49 (0)800-18 15 970</a></div>
                    </div>
                </div>
                <p>${msg}</p>`;
                break;

            case "NL":
                ModalText = `
                <h2>Er is iets misgegaan!</h2>
                <div>Neem contact met ons op via e-mail of chat voor snelle hulp.</div>
                <div class="company-services-modal-flex">
                    <div>
                        <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                        <div><a href="mailto:info-nl@dpj-workspace.com">info-nl@dpj-workspace.com</a></div>
                    </div>
                </div>
                <p>${msg}</p>`;
                break;

            default:
                ModalText = `
                <h2>Oh no, something went wrong!</h2>
                <div>Please contact us via email or chat for quick help.</div>
                <div class="company-services-modal-flex">
                    <div>
                        <div><div class="dpj-icon dpj-icon-letter-closed" data-icon="letter-closed"></div></div>
                        <div><a href="mailto:info@dpj.se">info@dpj.se</a></div>
                    </div>
                </div>
                <p>${msg}</p>`;
        }

        try {
            modals.ol.html(`
                <div class="modal-box" id="company-services-modal">
                <div class="close-modal">
                <img src="${prestashop.urls.img_url}icons/cross.svg" alt="close">
                </div>
                ${ModalText}
                </div>
                `);

            $("#company-services-modal").show();
            modals.togglePageOverlay();
            icons.init();
        } catch (error) {
            console.log(error)
        }
    },
    scrollToContact: () => {
        $(".scrollToContact").click(function (event) {
            event.preventDefault();
            helpers.scrollWindow(".contact");
        });
    },
    /**
     * Post the passed form and display a success or error message
     * 
     * @param {HTMLFormElement} form
     */
    postForm: (form) => {
        const formData = new FormData(form);
        const lang = formData.get("language");
        const originPage = formData.get("originPage");

        // Adding a try catch here becuse this does not seem to work on DEV
        try {
            window.dataLayer.push({
                'event': originPage.replaceAll(" ", "_"),
                'event_category': 'Forms',
                'event_label': 'Submit',
            });
            /*gtag('event', 'Submit', {
                'event_category': 'Forms',
                'event_label': originPage.replaceAll(" ", "_"),
            });*/
        } catch (error) {
            console.log(error)
        }

        const url = form.action
        const fetchOptions = {
            method: "POST",
            body: formData,
        };
        fetch(url, fetchOptions)
            .then(res => res.json())
            .then(json => {
                if (json.status === "OK") {
                    companyServices.displayOkMsg(lang)
                } else {
                    companyServices.displayFailMsg(lang, json.error)
                }
            })
            .catch(err => console.log(err))
    },
    /** 
     * set location field in contact form
     * 
     * @param {HTMLFormElement} form
     * @param {string} location 
     * @param {number} provider
     */
    setLocation: (form, location, provider) => {
        form.querySelectorAll(".contact__location-field")
            .forEach(element => {
                element.value = `${location} [${provider}]`;
            });
    },
    /**
     * Clear all input fields under the passed node
     * disregarding the submit button
     *  
     * @param {HTMLFormElement} form
     */
    clearForm: (form) => {
        form.querySelectorAll(".contact__input:not([type=submit]), .contact__input_textarea")
            .forEach(element => {
                element.value = "";
            });
    },
    insertContactFormFromFaq: () => {
        if ($(".insert-contact-form-from-faq").length) {
            $.get(prestashop.urls.base_url + "faq", function (data) {
                var parser = new DOMParser();
                var xmlParse = parser.parseFromString(data, "text/html");
                $(".insert-contact-form-from-faq").html(xmlParse.getElementsByClassName("contact-form-items")[0]);
                dpjFaq.init();
            });
        }
    },
    insertCompanyPagesCarouselNew: () => {
        if ($(".load-company-pages-carousel-new").length) {
            $.get(prestashop.urls.base_url + "content/137-company-pages-carousel-new", function (data) {
                var parser = new DOMParser();
                var xmlParse = parser.parseFromString(data, "text/html");
                $(".load-company-pages-carousel-new").html(xmlParse.getElementsByClassName("company-pages-carousel-new")[0]);
                companyServices.hideCompanyServiceFromCarouselNew();
            });
        }
    },
    hideCompanyServiceFromCarouselNew: () => {
        // Remove slide from Carousel if user is already on that page
        if ($(".company-pages-carousel-new .company-services-bottom-nav-block").length) {
            let locationPathLast = location.pathname.split("/")[location.pathname.split("/").length - 1];
            locationPathLast = locationPathLast.split("-")[0] + "-";
            $(".company-services-bottom-nav-block").each(function (index) {
                if ($(this).find("a").attr("href").includes(locationPathLast)) {
                    $(this).remove();
                }
            });
        }
    },
    initCombinationComparisonTable: () => {
        $('.combination-comparison-table-row').on('scroll', function () {
            var scrollLeft = $(this).scrollLeft();
            $('.combination-comparison-table-row').not(this).scrollLeft(scrollLeft);
        });
    },
}

